module.exports = __webpack_public_path__ + "assets/avatar_placeholder.ecb61769.svg";